<template>
  <div>
    <DashboardHeader title="Student Fees Switchboard 22">
      <div class="mt-16">
        <DashboardTiles :tiles="tiles"></DashboardTiles>
      </div>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import DashboardTiles from "@/components/myLibrary/DashboardTiles2024.vue";

export default {
  components: {
    DashboardHeader,
    DashboardTiles,
  },

  data: () => ({
    tiles: [
      {
        id: 3,
        icon: "mdi-cash-multiple",
        title: "Manage Fees",
        industry: "General",
        route: "school-fees-structures",
        param: "",
        alevel: 5,
        buttonText: "Enter",
      },
      {
        id: 6,
        icon: "mdi-cash-multiple",
        title: "Capture Bulk Payments",
        industry: "General",
        route: "bulk-payments-capturing",
        param: "",
        alevel: 7,
        buttonText: "Enter",
      },
      {
        icon: "mdi-eye",
        title: "Opening Balances",
        industry: "General",
        color: "deep-orange darken-4",
        route: "balance-brought-forward",
        buttonText: "Enter",
        alevel: 9,
        param: "",
      },

      {
        icon: "mdi-table",
        title: "Fees Sheet",
        industry: "General",
        color: "red darken-4",
        route: "fees-spreadsheet",
        buttonText: "Enter",
        alevel: 5,
        param: "",
      },
      {
        icon: "mdi-account-multiple-minus",
        title: "Students Owing",
        industry: "General",
        color: "red darken-4",
        route: "students-owing",
        buttonText: "Enter",
        alevel: 5,
        param: "",
      },
    ],
  }),
};
</script>
